// <pos-menu-grid/> — 菜單網格
// see architecture.md#L580

import { fetchMenu } from '../lib/api.js';
import { escapeHtml } from '../lib/utils/escape.js';

class PosMenuGrid extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.items = [];
    this.categories = [];
    this.activeCategory = null;
  }

  async connectedCallback() {
    this.render({ loading: true });
    try {
      const data = await fetchMenu();
      this.categories = data.categories || [];
      this.items = data.items || [];
      this.activeCategory = this.categories[0]?.id;
      this.render();
    } catch (err) {
      this.render({ error: err.message });
    }
  }

  render({ loading = false, error = null } = {}) {
    if (loading) {
      this.shadowRoot.innerHTML = `<div class="skeleton" style="height: 100%;"></div>`;
      return;
    }
    if (error) {
      this.shadowRoot.innerHTML = `<div style="color: var(--danger);">載入失敗：${escapeHtml(error)}</div>`;
      return;
    }

    const filteredItems = this.items.filter((i) => i.category_id === this.activeCategory);

    this.shadowRoot.innerHTML = `
      <style>
        :host { display: block; }
        .cats {
          display: flex;
          gap: var(--s-2);
          margin-bottom: var(--s-4);
          overflow-x: auto;
          padding-bottom: var(--s-2);
        }
        .cat {
          min-height: var(--touch-min);
          padding: var(--s-2) var(--s-4);
          background: var(--bg-surface);
          border: 1px solid var(--border);
          border-radius: var(--r-full);
          white-space: nowrap;
          cursor: pointer;
        }
        .cat[data-active="true"] {
          background: var(--brand-primary);
          color: var(--fg-on-brand);
        }
        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
          gap: var(--s-3);
        }
      </style>
      <div class="cats">
        ${this.categories.map((c) => `
          <div class="cat" data-id="${escapeHtml(c.id)}" data-active="${c.id === this.activeCategory}">${escapeHtml(c.name)}</div>
        `).join('')}
      </div>
      <div class="grid">
        ${filteredItems.map((item) => `
          <pos-menu-item data-id="${escapeHtml(item.id)}" data-name="${escapeHtml(item.name)}" data-price="${escapeHtml(item.price)}" data-desc="${escapeHtml(item.description || '')}"></pos-menu-item>
        `).join('')}
      </div>
    `;

    this.shadowRoot.querySelectorAll('.cat').forEach((el) => {
      el.addEventListener('click', () => {
        this.activeCategory = el.dataset.id;
        this.render();
      });
    });
  }
}

customElements.define('pos-menu-grid', PosMenuGrid);
